<template>
    <main id="login" class="w-100 h-100">
        <div class="d-flex justify-center justify-content-center">
            <div
                class="content h-100 d-flex flex-column justify-content-center align-items-center"
                style="width: 45%; margin-top: 50px; transition: 1s all"
            >
                <div class="content-form" style="width: 60%">
                    <div style="display: flex; justify-content: space-between; align-items: center">
                        <SupsisLogo />
                        <language-switch />
                    </div>
                    <div style="margin-top: 50px; color: #183b56; font-weight: 700; font-size: 35px">
                        <div style="line-height: 1">{{ $t("login.passwordForget") }}</div>
                    </div>
                    <div style="margin-top: 40px">
                        <div>
                            <span style="color: #183b56" class="font-weight-bold">{{
                                $t("login.passwordNewAgain")
                            }}</span>
                            <div style="margin-top: 3px">
                                <a-input
                                    :type="loginForm.hidePassword ? 'text' : 'password'"
                                    ref="userNameInput"
                                    v-model="loginForm.password"
                                    :placeholder="$t('login.passwordNewAgainPlaceholder')"
                                >
                                    <a-icon slot="prefix" type="lock" />
                                    <a-icon
                                        slot="suffix"
                                        :type="loginForm.hidePassword ? 'eye' : 'eye-invisible'"
                                        style="color: rgba(0, 0, 0, 0.45)"
                                        @click="loginForm.hidePassword = !loginForm.hidePassword"
                                    />
                                </a-input>
                            </div>
                        </div>
                        <div style="margin-top: 15px">
                            <span class="font-weight-bold" style="color: #183b56">{{
                                $t("login.passwordNewAgainTwo")
                            }}</span>
                            <div style="margin-top: 3px">
                                <a-input
                                    :type="loginForm.hidePassword ? 'text' : 'password'"
                                    ref="userNameInput"
                                    v-model="loginForm.repassword"
                                    :placeholder="$t('login.passwordNewAgainPlaceholderTwo')"
                                >
                                    <a-icon slot="prefix" type="lock" />
                                    <a-icon
                                        slot="suffix"
                                        :type="loginForm.hidePassword ? 'eye' : 'eye-invisible'"
                                        style="color: rgba(0, 0, 0, 0.45)"
                                        @click="loginForm.hidePassword = !loginForm.hidePassword"
                                    />
                                </a-input>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between" style="margin-top: 20px">
                            <div
                                class="text-center w-full text-white font-weight-bold"
                                style="border-radius: 8px; padding: 13px 0; font-size: 15px; width: 100%"
                                :style="{
                                    background:
                                        loginForm.password &&
                                        loginForm.repassword &&
                                        loginForm.repassword == loginForm.password
                                            ? '#ec4b1d'
                                            : '#C3CAD9',
                                }"
                                @click="doResetPassword"
                            >
                                {{ $t("login.passwordNew") }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" style="margin-top: 20px">
                            <hr color="#C3CAD9" width="50%" />
                            <div style="margin: 0px 5px; color: #183b56" width="100%">{{ $t("login.loginAnd") }}</div>
                            <hr color="#C3CAD9" width="50%" />
                        </div>
                        <div class="d-flex justify-content-between w-100" style="margin-top: 20px">
                            <router-link
                                to="/login"
                                class="w-100 text-white text-center font-weight-bold"
                                style="background: #183b56; border-radius: 8px; padding: 13px 0; font-size: 15px"
                            >
                                {{ $t("login.passwordAndLogin") }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions } from "vuex";
import PasswordForgot from "../../components/svg/PasswordForgot";
import SupsisLogo from "../../components/svg/SupsisLogo.vue";
import LanguageSwitch from "../../components/LanguageSwitch";

export default {
    name: "ForgotPassword",
    components: { PasswordForgot, SupsisLogo, LanguageSwitch },
    component: {
        PasswordForgot,
    },
    data() {
        return {
            loading: false,
            isSubmit: false,
            isClickable: true,
            loginForm: {
                hidePassword: false,
                password: "",
                repassword: "",
                token: this.$route.query.token,
                email: this.$route.query.email,
            },
            recaptchaSiteKey: "6Lf7tt4sAAAAAEa_UXb1pZoDCGuPRgooOun8nFiR",
        };
    },
    created() {},
    mounted() {
        if (this.recaptchaSiteKey) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=" + this.recaptchaSiteKey;
            document.head.appendChild(script);
        }
    },
    methods: {
        ...mapActions({
            resetPassword: "auth/resetPassword",
        }),
        getRecaptchaToken() {
            if (!this.recaptchaSiteKey || !window.grecaptcha) {
                return Promise.resolve(null);
            }
            return new Promise((resolve) => {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(this.recaptchaSiteKey, { action: "reset_password" }).then(resolve);
                });
            });
        },
        doResetPassword() {
            if (!this.isClickable) {
                return;
            }

            this.isSubmit = true;
            this.$validator.validateAll().then((response) => {
                if (this.loginForm.password !== this.loginForm.repassword) {
                    this.$bvToast.toast("Two password must be same", {
                        title: "Error",
                        variant: "danger",
                        solid: true,
                    });
                } else {
                    if (response) {
                        this.loading = true;
                        this.isClickable = false;
                        this.getRecaptchaToken().then((recaptchaToken) => {
                            this.resetPassword(Object.assign({}, this.loginForm, { recaptchaToken: recaptchaToken }))
                                .then((z) => {
                                    this.$bvToast.toast(
                                        "Your password successfully reset, please login with the new password",
                                        {
                                            title: "Successful",
                                            variant: "success",
                                            solid: true,
                                            duration: 50000,
                                        }
                                    );
                                    setTimeout(() => {
                                        this.$router.push("login");
                                    }, 6000);
                                })
                                .catch((error) => {
                                    console.error("error --> ", error);
                                    this.$bvToast.toast(error.response.data, {
                                        title: error.response.statusText || "Error",
                                        variant: "danger",
                                        solid: true,
                                    });
                                })
                                .finally(() => {
                                    this.loading = false;
                                    setTimeout(() => {
                                        this.isClickable = true;
                                    }, 10000);
                                });
                        });
                    }
                }
            });
        },
    },
};
</script>
